export function getText(
  value,
  division_name,
  parent_company_name,
  location_name
) {
  let text =
    value ||
    'By checking this box, you agree to receive promotional SMS messages from {{division_name}}. Message frequency may vary. Message and data rates may apply. Reply STOP to opt out or HELP for help.'

  let replacements = {
    division_name,
    parent_company_name,
    location_name,
  }

  return text.replace(/{{(.*?)}}/g, (_, key) => replacements[key] ?? '')
}
